import React from 'react'
import { useRouter } from 'next/router'
import cn from 'classnames'
import Image from 'next/image'

import PageLayout from '@/components/PageLayout'
import Button from '@/components/mawooButton'
import GuaranteeCard from '@/components/guaranteeCard'
import { MailIcon, PhoneIcon } from '@/components/icons'

import { Guarantee } from '@/types/index'

import s from './Overview.module.scss'

export const guarantees: Guarantee[] = [
  {
    icon: 'icons/health-guarantee.svg',
    title: '14-Day Health Guarantee',
    subtitle: '(All puppies)',
    coverPeriod: {
      title: 'Coverage Period',
      description: "First 14 days after your puppy's arrival.",
    },
    covered: {
      title: "What's Covered?",
      description:
        'Medical treatment of certain infectious diseases, contagious diseases, life-threatening illnesses, and cost of medicine for parasites. Replacement option for hereditary or congenital disorders.',
    },
  },
  {
    icon: 'icons/genetic-health-guarantee.svg',
    title: 'Extended Genetic Health Guarantee',
    subtitle: '(Select puppies)',
    coverPeriod: {
      title: 'Covered Period',
      description: 'Varies by puppy (Example: One year)',
    },
    covered: {
      title: "What's Covered?",
      description:
        'Medical treatment of hereditary or congenital disorders up to the purchase price of your puppy.',
      note: "Please reference the breeder's supplemental health guarantee for coverage, terms, and limitations",
    },
  },
]

const Options = () => {
  const router = useRouter()
  return (
    <>
      <div className={s.options}>
        {guarantees.map((guarantee, index) => (
          <GuaranteeCard key={index} guarantee={guarantee} />
        ))}
      </div>

      <div className={s.options_action}>
        <p className={s.options_action_text}>
          To learn more about covered conditions, excluded conditions, buyer's
          obligations, and how to file claim, please review our complete Health
          Guarantee terms.
        </p>
        <Button
          variant="primary"
          onClick={() => router.push('/health-guarantee-agreement')}
          className={s.options_action_btn}
        >
          Learn More
        </Button>
      </div>
    </>
  )
}

const Questions = () => {
  return (
    <div className={s.questions}>
      <p className={s.questions_title}>Questions?</p>
      <div className={s.questions_buttons}>
        <Button
          variant="outline"
          className={cn(s.questions_buttons_btn, s.questions_buttons_mail)}
          onClick={() => {
            window.location.href =
              'mailto:sales@mawoopets.com?subject=Subject&body=Body'
          }}
        >
          <MailIcon className={s.mail_icon} />
          Email Us
        </Button>
        <Button
          variant="secondary-outline"
          className={cn(s.questions_buttons_btn)}
          onClick={() => window.open('tel:1-888-488-7203')}
        >
          <PhoneIcon className={s.phone_icon} />
          <p className={s.questions_buttons_phone}>
            Call: 1 (888) 488-7203
            <span>9a-9p ET</span>
          </p>
        </Button>
      </div>
    </div>
  )
}
const heroComponent = (
  <>
    <div className={s.imageDesktop}>
      <Image
        src="/health-guarantee/overview-hero.png"
        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
        width={1074}
        height={250}
        quality={100}
        priority
        alt="Dog doctor"
      />
    </div>
    <div className={s.imageMobile}>
      <Image
        src="/health-guarantee/health-hero-mob.png"
        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
        width={400}
        height={200}
        quality={100}
        priority
        alt="Dog doctor"
      />
    </div>
  </>
)

const HealthGuarantee = () => {
  return (
    <PageLayout title="Health Guarantee Overview" hero={heroComponent}>
      <div className={s.guarantee_titles}>
        <h1 className={s.guarantee_title}>Mawoo Pets Health Guarantee</h1>
      </div>

      <div className={s.guarantee_wrapper}>
        <p className={s.guarantee_subtitle}>
          Our Health Guarantees are designed to protect your new puppy and
          provide you peace of mind.
        </p>
        <Options />
        <Questions />
      </div>
    </PageLayout>
  )
}

export default HealthGuarantee
